import React, { useEffect, useState } from 'react';
import { Translate } from 'react-redux-i18n';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../hooks';
import { RootState } from '../../../store';
import { getEventOrganizer } from '../../eventOrganizers/store/eventOrganizerActions';
import EventOrganizerInput from '../../eventOrganizers/input/EventOrganizerInput';
import Spinner from '../../../components/common/spinner';

const EditEventOrganizerContent = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const [loaded, setLoaded] = useState(false);
  const state = useSelector((s: RootState) => (s as any).eventOrganizer);

  useEffect(() => {
    if (id) dispatch(getEventOrganizer(Number(id)) as any);
  }, [id, dispatch]);

  useEffect(() => {
    if (state?.recordEdit?.ready === 0 && state?.recordEdit?.data) {
      setLoaded(true);
    }
  }, [state?.recordEdit]);

  if (!loaded) return <Spinner />;

  return (
    <>
      <h2>
        <Translate value='eventOrganizers.page.edit.title' />
      </h2>
      <EventOrganizerInput mode='edit' initialValue={state?.recordEdit?.data} />
    </>
  );
};

export default EditEventOrganizerContent;
